// MP135 G2 — Sentry init must run before <App /> renders so any
// import-time throw inside App / its lazy children gets captured.
// initWebSentry() is a no-op when VITE_SENTRY_DSN is unset so
// local dev / preview builds skip the wire-up.
import { initWebSentry, SentryErrorBoundary } from './lib/sentry';
initWebSentry();

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { FallbackErrorScreen } from './components/FallbackErrorScreen';
import { applyStandaloneDocumentBranding } from './lib/tenantHost';

// MP738 — on a standalone product's host, the tab title and icon are the
// product's from the first paint. No-op on the suite.
applyStandaloneDocumentBranding();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <SentryErrorBoundary
      fallback={({ error, resetError, eventId }) => (
        <FallbackErrorScreen
          error={error}
          resetError={resetError}
          eventId={eventId ?? undefined}
        />
      )}
    >
      <App />
    </SentryErrorBoundary>
  </React.StrictMode>,
);
